import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SignSuccessInfo.module.scss';
import {emptyFn} from '../../../../../shared';
import SigninMailIcon from '../../../../../components/style-guide/icons/SigninMail.icon';

export const SignInSuccessInfo = (props) => {
  const { email, onResetSignIn } = props;

  return (
    <div className={clsx('d-flex flex-column justify-content-center align-items-center mt-5 pt-5', styles.formContainer)}>
      <h1><SigninMailIcon/></h1>
      <h3 className="h3 mb-3 font-weight-normal">Revise su correo electrónico</h3>
      <p> Hemos enviado a <span className={styles.underline}>{email}</span> un enlace para acceder. </p>
      <p className={styles.warning}>Si el correo no está en su bandeja de entrada verifique la carpeta SPAM.</p>
      <p className="mt-4 mb-1"> ¿Se ha equivocado? </p>
      <p className={clsx('d-flex justify-content-center btn-clear', styles.underline)} tabIndex="0" role="button" aria-pressed="false" onClick={onResetSignIn}>
        Vuelva a ingresar su correo electrónico
      </p>
    </div>
  );
};

SignInSuccessInfo.propTypes = {
  email: PropTypes.string,
  onResetSignIn: PropTypes.func
};

SignInSuccessInfo.defaultProps = {
  email: '',
  onResetSignIn: emptyFn
};

export default React.memo(SignInSuccessInfo);